import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Wrench, Newspaper } from "lucide-react";
import { MarketingLayout } from "../../components/marketing/MarketingLayout";
import { SEO } from "../../components/seo/SEO";
import { breadcrumbSchema } from "../../components/seo/schema";

const SECTIONS = [
  { to: "/resources/blog", icon: Newspaper, title: "Blog", desc: "Practical guides on dispatching, CRM, AI receptionists, invoicing, and running a home service business." },
  { to: "/resources/guides", icon: BookOpen, title: "Guides", desc: "In-depth guides for evaluating and adopting home service software." },
  { to: "/resources/tools", icon: Wrench, title: "Tools", desc: "Free tools and calculators for home service businesses." },
];

export default function ResourcesHub() {
  const breadcrumb = [{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }];
  return (
    <MarketingLayout breadcrumb={breadcrumb}>
      <SEO
        title="Resources for Home Service Businesses | ServiceGuru Pro"
        description="Guides, blog articles, and tools to help HVAC, plumbing, electrical, and other home service businesses run more efficiently."
        path="/resources"
        jsonLd={[breadcrumbSchema(breadcrumb)]}
      />
      <section className="max-w-4xl mx-auto px-5 lg:px-8 pt-12 pb-14 text-center">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tight leading-[1.05] mb-5" data-testid="resources-hub-h1">
          Resources
        </h1>
        <p className="text-[15.5px] text-slate-400 leading-relaxed max-w-2xl mx-auto">
          Practical, no-fluff guidance for running a home service business — written from real patterns, not filler.
        </p>
      </section>
      <section className="max-w-4xl mx-auto px-5 lg:px-8 pb-20 grid grid-cols-1 sm:grid-cols-3 gap-5">
        {SECTIONS.map((s) => (
          <Link
            key={s.to}
            to={s.to}
            data-testid={`resources-hub-card-${s.title.toLowerCase()}`}
            className="rounded-2xl border border-white/10 bg-white/[0.02] p-6 hover:border-blue-400/50 hover:bg-white/[0.04] transition-colors group"
          >
            <div className="h-10 w-10 rounded-xl bg-blue-600/15 border border-blue-500/20 flex items-center justify-center mb-4">
              <s.icon className="h-5 w-5 text-blue-400" />
            </div>
            <h2 className="text-white font-semibold text-[15px] mb-1.5 group-hover:text-blue-400 transition-colors">{s.title}</h2>
            <p className="text-[13px] text-slate-500 leading-relaxed">{s.desc}</p>
          </Link>
        ))}
      </section>
    </MarketingLayout>
  );
}
